import classNames from 'classnames';
import {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';

const useFadeIn = () => {
  const [isIn, setIsIn] = useState(false);

  const {ref, inView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
    root: document.body,
  });

  useEffect(() => {
    if (inView) setIsIn(true);
  }, [inView]);

  return {
    fadeClass: classNames('useFadeIn', {'useFadeIn--in': isIn}),
    ref,
  };
};

export default useFadeIn;
